import "./styles.scss";
import "reactjs-popup/dist/index.css";

import Popup from "reactjs-popup";
import moment from "moment-timezone";
import TimezonePicker from "react-timezone";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";

import {
  getCountries,
  putAffiliate,
  updateUserInfo,
  getAdminUserInfo,
  getGlobalLanguages,
  // postAffiliateTax,
  postAffiliatePayment,
} from "../../../store/middleware";
import PhotoAvatar from "../../PhotoAvatar";
import ModalChangePassword from "../../ModalChangePassword";
import { decryptIfEncrypted } from "../../../utils/fieldDecryptor";
import linguitoPNG from "../../../assets/images/icons/linguito.png";
import { SCButtonAddInput } from "../../../components/Buttons/styles";
import { endLoading, initLoading } from "../../../store/slices/generics.slice";
import InputForClassTool from "../../../components/elements/NewInputs/InputForClassTool";

function PersonalInfo() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { plans } = useSelector((state) => state.studentReducer);
  const { affiliateInfo } = useSelector((state) => state.affiliateReducer);

  const [validations] = useState({});
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [gender, setGender] = useState("");
  const [address, setAddress] = useState("");
  const [timezone, setTimezone] = useState("");
  const [picture, setPicture] = useState(null);
  const [students, setStudents] = useState([]);
  const [teachers, setTeachers] = useState([]);
  const [countryId, setCountryId] = useState(0);
  const [isActive, setIsActive] = useState(true);
  const [classTool, setClassTool] = useState("");
  const [birthDate, setBirthDate] = useState("");
  const [countries, setCountries] = useState([]);
  const [paymentID, setPaymentID] = useState("");
  const [userPhones, setUserPhones] = useState([]);
  const [alerttitle, setAlertTitle] = useState("");
  const [openalert, setOpenAlert] = useState(false);
  const [paymentType, setPaymentType] = useState("");
  const [classToolId, setClassToolId] = useState("");
  const [paymentValue, setPaymentValue] = useState("");
  const [firstAccess, setFirstAccess] = useState(false);
  const [openmodalpass, setOpenModalPass] = useState(false);
  const [globallanguages, setGlobalLanguages] = useState([]);
  const [alertdescription, setAlertDescription] = useState("");
  const [userEmails, setUserEmails] = useState([{ email: "", notify: true }]);
  const [languages, setLanguages] = useState([{ languageId: 0, isNative: true }]);
  const [bilingueNativo, setBilingueNativo] = useState({ bilingue: false, nativo: true });
  const [languagesTeacher, setLanguagesTeacher] = useState([{ languageId: 0, isNative: true }]);
  const [affiliateTaxInformations, setAffiliateTaxInformations] = useState({
    city: "",
    state: "",
    taxId: "",
    zipcode: "",
    address1: "",
    fullname: "",
    address2: "",
    birthDate: "",
    personType: "",
    taxIdType: "PF",
    whereLiveCountryId: "",
    // taxClassification: "",
    citizenshipCountryId: "",
  });

  const allTaxIdType = [
    { id: "SSN", name: "SSN (US Residents)" },
    { id: "CPF", name: "CPF (Brasil)" },
    { id: "RFC", name: "RFC (México)" },
    { id: "NIT", name: "NIT (Colombia)" },
    { id: "other", name: t("OTHER") },
  ];

  const loadInfos = () => {
    if (affiliateInfo?.user?.id > 0) callApi(false);
  };

  const callApi = async (showModal) => {
    await dispatch(initLoading());

    if (!showModal) {
      await dispatch(getCountries()).then((res) => setCountries(res));
      await dispatch(getGlobalLanguages()).then((res) => setGlobalLanguages(res));
    }

    let urlCall = `admin/users/${id}`;
    if (affiliateInfo?.user.role === "student") urlCall = `studentManagement/getbyuser/${id}`;
    else if (affiliateInfo?.user.role === "teacher") urlCall = `teachermanagement/getbyuser/${id}`;

    await dispatch(getAdminUserInfo(urlCall))
      .then((res) => {
        if (!res.success || !res.result.items || res.result.items.length === 0) return;

        const item = res?.result?.items[0];
        const itemAffiliateTaxInformations = affiliateInfo?.affiliateTaxInformations[0];

        if (affiliateInfo?.user.role === "student") {
          if (item.students && item.students.length > 0) {
            item.languages = item.students[0].studentLanguages;
            item.classTool = item.students[0].classTool;
            item.classToolId = item.students[0].classToolId;
          }
        } else if (affiliateInfo?.user.role === "teacher") {
          if (item.teachers && item.teachers.length > 0) item.languages = item.teachers[0].teacherLanguages;
        }

        if (affiliateInfo?.user.role === "student" || affiliateInfo?.user.role === "teacher") {
          if (item.languages && item.languages.length > 0) {
            item.languages.sort((x, y) => (x.isNative === y.isNative ? 0 : x.isNative ? -1 : 1));
          } else if (item.languages && item.languages.length === 0) {
            item.languages = [{ languageId: 0, isNative: true }];
          }
        }

        if (item.userPhones.length === 0) item.userPhones = [{ userPhoneTypeId: 15, phone: "" }];
        if (item.picture !== null) item.oldPicture = item.picture;

        let emailsForm = [];

        if (item?.email) {
          emailsForm.push({ email: decryptIfEncrypted(item?.email), notify: true });

          if (item?.userEmails.length > 0) {
            item?.userEmails.forEach(
              (item) =>
                item?.email !== item.email &&
                emailsForm.push({ email: decryptIfEncrypted(item?.email), notify: item.notify }),
            );
          }
        }

        const responseUserPhones = item.userPhones.map((item) => {
          return { ...item, phone: decryptIfEncrypted(item.phone) };
        });

        setUserEmails(emailsForm);
        setUserPhones(responseUserPhones);

        setPicture(item?.picture);
        setTimezone(item?.timezone);
        setStudents(item?.students);
        setTeachers(item?.teachers);
        setLanguages(item?.languages);
        setClassTool(item?.classTool);
        setCountryId(item?.countryId);
        setClassToolId(item?.classToolId);
        setFirstAccess(item?.firstAccess);
        setName(decryptIfEncrypted(item?.name));
        setEmail(decryptIfEncrypted(item?.email));
        setGender(decryptIfEncrypted(item?.gender));
        setAddress(decryptIfEncrypted(item?.address));
        setBirthDate(decryptIfEncrypted(item?.birthDate));

        setPaymentType(decryptIfEncrypted(affiliateInfo?.affiliatePaymentMethods[0]?.provider));
        setPaymentID(decryptIfEncrypted(affiliateInfo?.affiliatePaymentMethods[0]?.providerUser));
        setLanguages([{ languageId: affiliateInfo?.nativeLanguageId, isNative: true }]);

        setIsActive(affiliateInfo?.active);
        setAddress(decryptIfEncrypted(affiliateInfo?.affiliateTaxInformations[0].address1));
        setAffiliateTaxInformations({
          city: decryptIfEncrypted(itemAffiliateTaxInformations.city),
          taxId: decryptIfEncrypted(itemAffiliateTaxInformations.taxId),
          state: decryptIfEncrypted(itemAffiliateTaxInformations.state),
          zipcode: decryptIfEncrypted(itemAffiliateTaxInformations.zipcode),
          address1: decryptIfEncrypted(itemAffiliateTaxInformations.address1),
          address2: decryptIfEncrypted(itemAffiliateTaxInformations.address2),
          taxIdType: decryptIfEncrypted(itemAffiliateTaxInformations.taxIdType),
          personType: decryptIfEncrypted(itemAffiliateTaxInformations.personType),
          whereLiveCountryId: decryptIfEncrypted(itemAffiliateTaxInformations.whereLiveCountryId),
          citizenshipCountryId: decryptIfEncrypted(itemAffiliateTaxInformations.citizenshipCountryId),
        });

        if (affiliateInfo?.user.role === "student") {
          setBilingueNativo({
            bilingue: item?.students[0]?.typeTeacherPreference === "bilingual" && true,
            nativo: item?.students[0]?.typeTeacherPreference === "native" && true,
          });
        }

        if (affiliateInfo?.user.role === "teacher") {
          setPaymentID(item?.teachers[0]?.paymentId);
          setPaymentType(item?.teachers[0]?.paymentType);
          setPaymentValue(item?.teachers[0]?.paymentValue);
          setLanguagesTeacher(item?.teachers[0]?.teacherLanguages);
        }

        if (showModal) {
          setOpenAlert(true);
          setAlertTitle(t("SAVE_FORM_TITLE"));
          setAlertDescription(t("SAVE_FORM_DESCRIPTION"));
        }
      })
      .catch((err) => console.log("ERRO GET USERS ", err));
    await dispatch(endLoading());
  };

  const closeAlert = () => {
    setOpenAlert(false);
  };

  const addEmail = (e) => {
    e.preventDefault();
    setUserEmails((state) => [...state, { email: "", notify: true }]);
  };

  const addPhone = (e) => {
    e.preventDefault();
    setUserPhones((state) => [...state, { userPhoneTypeId: "", phone: "" }]);
  };

  const removeEmail = (e, findIndex) => {
    e.preventDefault();
    setUserEmails(userEmails.filter((value, index) => index !== findIndex));
  };

  const addLanguage = (e) => {
    e.preventDefault();
    setLanguages((state) => [...state, { languageId: 0, isNative: false }]);
  };

  const removeLanguage = (e, findIndex) => {
    e.preventDefault();
    setLanguages(languages.filter((value, index) => index !== findIndex));
  };

  const removePhone = (e, findIndex) => {
    e.preventDefault();
    setUserPhones(userPhones.filter((value, index) => index !== findIndex));
  };

  const handleChangeList = async (e, index) => {
    e.preventDefault();

    const { name, value } = e.target;

    if (name === "email") {
      setUserEmails((state) => state.map((item, i) => (i === index ? { ...item, email: value } : item)));
    }

    if (name === "notify") {
      setUserEmails((state) => state.map((item, i) => (i === index ? { ...item, notify: !item.notify } : item)));
    }

    if (name === "phone") {
      setUserPhones((state) => state.map((item, i) => (i === index ? { ...item, phone: value } : item)));
    }

    if (name === "userPhoneTypeId") {
      setUserPhones((state) => state.map((item, i) => (i === index ? { ...item, userPhoneTypeId: value } : item)));
    }

    if (name === "language") {
      setLanguages((state) =>
        state.map((item, i) =>
          i === index ? { languageId: Number(value), isNative: index === 0 ? true : false } : item,
        ),
      );
    }
  };

  const handleChange = (e) => {
    const target = e.target;
    const value = target.type === "checkbox" ? target.checked : target.value;

    switch (target.name) {
      case "name":
        setName(value);
        setAffiliateTaxInformations((state) => ({ ...state, fullname: value }));
        break;
      case "email":
        setEmail(value);
        break;
      case "gender":
        setGender(value);
        break;
      case "birthDate":
        setBirthDate(value);
        setAffiliateTaxInformations((state) => ({ ...state, birthDate: value }));
        break;
      case "countryId":
        setCountryId(value);
        setAffiliateTaxInformations((state) => ({ ...state, whereLiveCountryId: Number(value) }));
        break;
      case "classToolId":
        setClassToolId(value);
        break;
      case "address":
        setAddress(value);
        setAffiliateTaxInformations((state) => ({ ...state, address1: value }));
        break;
      case "classTool":
        setClassTool(value);
        break;
      case "citizenshipCountryId":
        setAffiliateTaxInformations((state) => ({ ...state, citizenshipCountryId: Number(value) }));
        break;
      case "address2":
        setAffiliateTaxInformations((state) => ({ ...state, address2: value }));
        break;
      case "city":
        setAffiliateTaxInformations((state) => ({ ...state, city: value }));
        break;
      case "zipcode":
        setAffiliateTaxInformations((state) => ({ ...state, zipcode: value }));
        break;
      case "taxIdType":
        setAffiliateTaxInformations((state) => ({ ...state, taxIdType: value }));
        break;
      case "taxId":
        setAffiliateTaxInformations((state) => ({ ...state, taxId: value }));
        break;
      case "state":
        setAffiliateTaxInformations((state) => ({ ...state, state: value }));
        break;
      default:
        break;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (Object.values(validations).indexOf(true) < 0) {
      let formData = {
        name: name.toString(),
        email: email.toLowerCase(),
        address: address,
        countryId: Number(countryId),
        id: affiliateInfo?.user?.id,
        role: affiliateInfo?.user?.role,
        gender: gender,
        birthDate: birthDate,
        timezone: timezone,
        userEmails: userEmails,
        userPhones: userPhones,
        classTool: classTool,
        classToolId: classToolId,
      };

      let urlCall = `admin/users`;
      if (affiliateInfo?.user?.role === "student") {
        urlCall = `studentManagement/updatePersonalInformation`;

        let newlanguages = languages;
        if (newlanguages && languages.length > 0) {
          const nativeLanguages = newlanguages.filter((l) => l.isNative);
          if (nativeLanguages.length !== 1) {
            for (let index = 0; index < newlanguages.length; index++) {
              newlanguages[index].isNative = false;
            }
            newlanguages[0].isNative = true;
          }
        }
        if (students && students.length > 0) {
          let student = students[0];
          student.studentLanguages = newlanguages;
          student.languages = newlanguages;
          formData.student = student;
          student.classTool = classTool;
          student.classToolId = classToolId;

          formData.typeLanguage = bilingueNativo.bilingue ? "bilingual" : "native";
          formData.firstAccess = false;
        }
      } else if (affiliateInfo?.user?.role === "teacher") {
        urlCall = `teachermanagement`;
        let teacher = teachers[0];
        teacher.languages = languages;
        delete teacher.updatedAt;
        delete teacher.createdAt;
        delete teacher.deletedAt;
        delete teacher.teacherAvailabilities;
        delete teacher.teacherLevels;
        delete teacher.teacherLanguages;
        delete teacher.levels;
        formData.teacher = teacher;
        formData.payment = {
          paymentId: paymentID,
          paymentType: paymentType,
          paymentValue: paymentValue,
        };
      }

      formData.userEmails?.map((email) => {
        delete email.id;
        delete email.userId;
        delete email.updatedAt;
        delete email.createdAt;
        delete email.deletedAt;
        delete email.userPhoneType;
      });

      formData.userPhones.map((phone) => {
        delete phone.id;
        delete phone.userId;
        delete phone.updatedAt;
        delete phone.createdAt;
        delete phone.deletedAt;
        delete phone.userPhoneType;
      });

      try {
        formData.firstAccess = false;

        const bodyAffiliate = {
          active: isActive,
          id: affiliateInfo?.id,
          nativeLanguageId: languages[0].languageId,
          considerYourselfInfluencer: affiliateInfo?.considerYourselfInfluencer,
          followingTotalAllPlatforms: affiliateInfo?.followingTotalAllPlatforms,
          termsAccepted: affiliateInfo?.termsAcceptedsAt === null ? false : true,
        };

        const bodyAffiliatePayment = {
          provider: paymentType,
          providerUser: paymentID,
          affiliateId: affiliateInfo.id,
        };

        await dispatch(putAffiliate(bodyAffiliate))
          .then(async () => {
            if (
              paymentType !== affiliateInfo?.affiliatePaymentMethods[0]?.provider ||
              paymentID !== affiliateInfo?.affiliatePaymentMethods[0]?.providerUser
            ) {
              paymentType !== "" && paymentID !== "" && dispatch(postAffiliatePayment(bodyAffiliatePayment));
            }

            // if (
            //   affiliateTaxInformations.address1 !==itemAffiliateTaxInformations?.address1 ||
            //   affiliateTaxInformations.address2 !==itemAffiliateTaxInformations?.address2 ||
            //   affiliateTaxInformations.citizenshipCountryId !==
            //    itemAffiliateTaxInformations?.citizenshipCountryId ||
            //   affiliateTaxInformations.city !==itemAffiliateTaxInformations?.city ||
            //   affiliateTaxInformations.taxId !==itemAffiliateTaxInformations?.taxId ||
            //   affiliateTaxInformations.taxIdType !==itemAffiliateTaxInformations?.taxIdType ||
            //   affiliateTaxInformations.whereLiveCountryId !==
            //    itemAffiliateTaxInformations?.whereLiveCountryId ||
            //   affiliateTaxInformations.state !==itemAffiliateTaxInformations?.state ||
            //   affiliateTaxInformations.zipcode !==itemAffiliateTaxInformations?.zipcode ||
            //   affiliateTaxInformations.fullname !==itemAffiliateTaxInformations?.fullname
            //   // affiliateTaxInformations.birthDate !==itemAffiliateTaxInformations?.birthDate
            // ) {
            //   dispatch(
            //     postAffiliateTax({
            //       ...affiliateTaxInformations,
            //       userId: affiliateInfo?.userId,
            //       affiliateId: affiliateInfo?.id,
            //     }),
            //   );
            // }

            await dispatch(updateUserInfo(urlCall, JSON.parse(JSON.stringify(formData)), "affiliate")).then((res) => {
              if (!res || !res?.data?.success) return;
              //callApi(true);
            });
          })
          .catch((error) => {
            setOpenAlert(true);
            setAlertTitle(t("ERROR"));
            setAlertDescription(error?.response?.data.error[0]?.message);
          });
      } catch (error) {
        if (error) {
          setOpenAlert(true);
          setAlertTitle(t("ERROR"));
          setAlertDescription(t("ERROR_DIALOG"));
        }
      }
    } else {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("INVALID_FORM_DESCRIPTION"));
    }
  };

  const openModalPassword = (e) => {
    e.preventDefault();
    setOpenModalPass(true);
  };

  const handleClickBilingueNativo = (e, type) => {
    e.preventDefault();

    if (type === "bilingue") setBilingueNativo({ bilingue: true, nativo: false });
    else setBilingueNativo({ bilingue: false, nativo: true });
  };

  const ruleDisplayNativeBilingue = () => {
    let newArrayLang = [];
    for (let i = 0; i < plans?.length; i++) {
      plans[i]?.studentPlanLanguages?.map((lang) =>
        plans[i].student?.studentLevelGrades.filter((grade) => {
          if (grade.lingoLanguageId === lang.lingoLanguageId)
            newArrayLang.push({ flag: lang.lingoLanguage.flag, level: grade.level.level });
        }),
      );
    }

    return newArrayLang.some(
      (item) => (item.flag === "US" || item.flag === "FR") && !["A0", "A1"].includes(item.level),
    );
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    loadInfos();
    // eslint-disable-next-line
  }, []);

  const nativeLanguage = languages?.find((item) => item.isNative);
  const validationLanguageNative = nativeLanguage ? nativeLanguage?.languageId : null;

  let dataNew = moment(new Date()).utc().tz(timezone);

  moment.utc().tz(timezone);

  let dataTimeZone = moment(dataNew).format("LT");

  if (affiliateInfo.length) return;

  return (
    <div className="view">
      <div className="containerPersonalInfo">
        <div className="tabs">
          <div className="tab-content">
            <div className="box">
              <PhotoAvatar userID={affiliateInfo?.userId} picture={picture} setPicture={setPicture} />

              <form className="formulario">
                <div className="wrapperBlock">
                  <h4 className="textBlock">{t("PERSONAL_DATA")}</h4>
                </div>

                <div>
                  <label htmlFor="name" required={validations["name"]}>
                    {t("NAME")}
                  </label>
                  <span className="invalid">{validations["name"] && t("REQUIRED_FIELD")}</span>
                </div>
                <input
                  type="text"
                  value={name}
                  placeholder={t("NAME_PLACEHOLDER")}
                  name="name"
                  id="name"
                  onChange={handleChange}
                  required
                />

                {userEmails.length &&
                  userEmails?.map((item, index) => {
                    return (
                      <div key={index}>
                        <div>
                          <label htmlFor={"email" + index}>{index === 0 ? t("EMAIL") : t("EXTRA_EMAIL")} </label>
                        </div>
                        <div className="notification">
                          <input
                            required
                            type="text"
                            name="email"
                            id={"email" + index}
                            value={item.email}
                            className="newemail inputMobile"
                            placeholder={index === 0 ? t("EMAIL_PLACEHOLDER") : t("EXTRA_EMAIL_PLACEHOLDER")}
                            onChange={(e) => {
                              if (index === 0) handleChange(e);
                              handleChangeList(e, index);
                            }}
                          />
                          <div className="switchBox">
                            <div className="switch__container">
                              <input
                                className="switch switch--shadow"
                                name="notify"
                                id={"notify" + index}
                                type="checkbox"
                                onChange={(e) => handleChangeList(e, index)}
                                checked={item.notify}
                              />
                              <label className="labelNotify" htmlFor={"notify" + index}>
                                <span>{t("NOTIFICATION")}</span>
                                <span className="doubleClick">{t("DOUBLE_CLICK")}</span>
                              </label>
                            </div>
                          </div>
                          {index > 0 ? (
                            <SCButtonAddInput id={index} name="remove" onClick={(e) => removeEmail(e, index)}>
                              {t("DELETE")} <i className="fa fa-times-circle-o fa-lg"></i>
                            </SCButtonAddInput>
                          ) : (
                            <SCButtonAddInput name="addemail" onClick={(e) => addEmail(e)}>
                              {t("ADD_EMAIL")} +
                            </SCButtonAddInput>
                          )}
                        </div>
                      </div>
                    );
                  })}

                <div className="inputs">
                  <div className="lineInputs">
                    <div>
                      <label htmlFor="gender">{t("GENDER")}</label>
                      <span className="invalid">{validations["gender"] && t("REQUIRED_FIELD")}</span>
                    </div>
                    <select name="gender" value={gender} onChange={handleChange}>
                      <option value="">{t("SELECT")}</option>
                      <option value="notInformed">{t("NOT_INFORMED")}</option>
                      <option value="male">{t("MALE")}</option>
                      <option value="female">{t("FEMALE")}</option>
                    </select>
                  </div>

                  <div className="lineInputs">
                    <div>
                      <label htmlFor="birthDate">{t("BIRTH_DATE")}</label>
                      <span className="invalid">{validations["birthday"] && t("REQUIRED_FIELD")}</span>
                    </div>

                    <input type="date" id="date" name="birthDate" value={birthDate} onChange={handleChange} />
                  </div>
                </div>

                <div className="wrapperBlock">
                  <h4 className="textBlock">{t("COUNTRY")}</h4>
                </div>

                <div className="inputs">
                  <div className="lineInputs">
                    <div>
                      <label htmlFor="countryId">{t("COUNTRY")}</label>
                      <span className="invalid">{validations["countryId"] && t("REQUIRED_FIELD")}</span>
                    </div>
                    <select name="countryId" value={countryId} onChange={handleChange}>
                      <option value="0">{t("SELECT")}</option>
                      {countries.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="lineInputs">
                    <div>
                      <label>{t("CITIZENSHIP_COUNTRY")}</label>
                    </div>
                    <select
                      onChange={handleChange}
                      name="citizenshipCountryId"
                      value={affiliateTaxInformations.citizenshipCountryId}
                    >
                      <option value="0">{t("SELECT")}</option>
                      {countries.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="inputs">
                  <div className="lineInputs timezoneCard">
                    <div>
                      <label htmlFor="timezone">{t("TIMEZONE")} </label>
                      <span className="invalid">{validations["timezone"] && t("REQUIRED_FIELD")}</span>
                    </div>
                    <TimezonePicker
                      value={timezone}
                      onChange={(timezoneName) => setTimezone(timezoneName)}
                      inputProps={{ placeholder: "Select Timezone...", name: "timezone" }}
                    />
                  </div>
                  <div className="lineInputs">
                    <p>
                      {t("CURRENT_TIME")}
                      <br /> {t("IN_THIS_TIMEZONE")}: {dataTimeZone}
                    </p>
                  </div>
                </div>

                <div>
                  <label htmlFor="address">{t("ADDRESS")} </label>
                  <span className="invalid">{validations["address"] && t("REQUIRED_FIELD")}</span>
                </div>
                <input
                  required
                  name="address"
                  value={address}
                  onChange={handleChange}
                  placeholder={t("ADDRESS_PLACEHOLDER")}
                />

                <div>
                  <label htmlFor="name">{t("ADDRESS") + " 02"}</label>
                </div>
                <input
                  type="text"
                  name="address2"
                  onChange={handleChange}
                  placeholder={t("ADDRESS") + " 02"}
                  value={affiliateTaxInformations.address2}
                />

                <div className="inputs">
                  <div className="lineInputs">
                    <div>
                      <label>{t("CITY")}</label>
                    </div>
                    <input
                      name="city"
                      style={{ width: 131 }}
                      onChange={handleChange}
                      value={affiliateTaxInformations.city}
                    />
                  </div>

                  <div className="lineInputs">
                    <div>
                      <label>{t("STATE")}</label>
                    </div>
                    <input
                      name="state"
                      style={{ width: 131 }}
                      onChange={handleChange}
                      value={affiliateTaxInformations.state}
                    />
                  </div>

                  <div className="lineInputs">
                    <div>
                      <label>{t("ZIPCODE")}</label>
                    </div>

                    <input
                      name="zipcode"
                      style={{ width: 131 }}
                      onChange={handleChange}
                      value={affiliateTaxInformations.zipcode}
                    />
                  </div>
                </div>

                {userPhones.map((item, index) => {
                  return (
                    <div key={index} className="inputs telefone">
                      <div className="lineInputs">
                        <div>
                          <label htmlFor={"phone" + index}>{t("TELEPHONE")}</label>
                          {index === 0 && (
                            <span className="invalid">{validations["phone"] && t("REQUIRED_FIELD")}</span>
                          )}
                        </div>
                        <input
                          id={"phone" + index}
                          className="inputMobile"
                          required={index === 0}
                          placeholder={t("PHONE_PLACEHOLDER")}
                          name="phone"
                          value={item.phone}
                          onChange={(e) => handleChangeList(e, index)}
                        />
                      </div>
                      <div className="lineInputs">
                        <div>
                          <label htmlFor={"userPhoneTypeId" + index}>{t("TYPE")}</label>
                        </div>
                        <select
                          className="inputMobile"
                          name="userPhoneTypeId"
                          id={"phoneType" + index}
                          value={item.userPhoneTypeId || 15}
                          onChange={(e) => handleChangeList(e, index)}
                        >
                          <option value="15">{t("SELECT")}</option>
                          <option value="1">{t("COMMERCIAL")}</option>
                          <option value="2">{t("RESIDENCIAL")}</option>
                          <option value="3">{t("CELLPHONE")}</option>
                          <option value="4">{t("WHATSAPP")}</option>
                        </select>
                      </div>
                      {index === 0 && (
                        <div className="lineInputs">
                          <SCButtonAddInput name="addphone" onClick={(e) => addPhone(e)}>
                            {t("BTN_ADD_TEL")} +
                          </SCButtonAddInput>
                        </div>
                      )}
                      {index > 0 && (
                        <SCButtonAddInput id={index} name="remove" onClick={(e) => removePhone(e, index)}>
                          {t("DELETE")} <i className="fa fa-times-circle-o fa-lg"></i>
                        </SCButtonAddInput>
                      )}
                    </div>
                  );
                })}

                {firstAccess === false && affiliateInfo?.user.role === "student" && (
                  <>
                    <div className="wrapperBlock">
                      <h4 className="textBlock">{t("CLASS_LINK")}</h4>
                    </div>

                    <div className="inputs selectClass">
                      <div className="lineInputs">
                        <InputForClassTool
                          tabindex="-1"
                          name="classTool"
                          readonly="readonly"
                          aria-disabled="true"
                          inputChange={handleChange}
                          data={{ value: classTool, required: false }}
                        />
                      </div>
                      <div className="lineInputs">
                        <div>
                          <label htmlFor="classToolId">{t("TOOL_ID")}</label>
                          <span className="invalid">{validations["classToolId"]}</span>
                        </div>
                        <a href={classToolId} target="_blank" rel="noreferrer">
                          <div className="classToolId">{classToolId}</div>
                        </a>
                      </div>
                    </div>

                    {ruleDisplayNativeBilingue() && (
                      <>
                        <div className="wrapperBlock">
                          <h4 className="textBlock">{t("TEACHER")}</h4>
                        </div>

                        <div className="wrapperSelectTeacher">
                          <button
                            onClick={(e) => handleClickBilingueNativo(e, "nativo")}
                            className={`buttonSelectTeacher ${bilingueNativo.nativo && "buttonSelectTeacherActive"}`}
                          >
                            {t("NATIVE")}
                          </button>
                          <button
                            onClick={(e) => handleClickBilingueNativo(e, "bilingue")}
                            className={`buttonSelectTeacher ${bilingueNativo.bilingue && "buttonSelectTeacherActive"}`}
                          >
                            {t("BILINGUAL")}
                          </button>

                          <Popup
                            on={"hover"}
                            position={"right center"}
                            trigger={<img className="linguitoPNG" src={linguitoPNG} />}
                            style={{ width: 300, backgroundColor: "red" }}
                          >
                            <div style={{ width: 300 }}>
                              <p style={{ textAlign: "justify", color: "#555D67" }}>
                                {t("MESSAGE_INFO_BILINGUE_NATIVO")}
                              </p>
                            </div>
                          </Popup>
                        </div>
                      </>
                    )}
                  </>
                )}

                <div className="wrapperBlock">
                  <h4 className="textBlock">{t("TAX_INFORMATION")}</h4>
                </div>

                <div className="wrapperTaxInformation">
                  <div className="inputs">
                    <div className="lineInputs">
                      <div>
                        <label>{t("FISCAL_DOCUMENT")}</label>
                      </div>
                      <select name="taxIdType" onChange={handleChange} value={affiliateTaxInformations.taxIdType}>
                        {allTaxIdType.map((item, i) => (
                          <option key={i} value={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="lineInputs">
                      <div>
                        <label>‎</label>
                      </div>

                      <input name="taxId" onChange={handleChange} value={affiliateTaxInformations.taxId} />
                    </div>
                  </div>
                </div>

                <div className="wrapperBlock">
                  <h4 className="textBlock">{t("PAYMENT")}</h4>
                </div>

                <div className="wrapperPayment">
                  <div className="lineInputs">
                    <div>
                      <label>{t("PAYMENT")}</label>
                    </div>
                    <select name="paymentType" value={paymentType} onChange={(e) => setPaymentType(e.target.value)}>
                      <option value="">{t("SELECT")}</option>
                      <option value="payoneer">Payoneer</option>
                      <option value="paypal">Paypal</option>
                      <option value="zelle">Zelle</option>
                      {/* {affiliateInfo?.user?.countryId === 212 && <option value="venmo">Venmo</option>} */}
                    </select>
                  </div>

                  <div className="lineInputs">
                    <label htmlFor="payment">{t("PAYMENT_ID")}</label>
                    <input
                      type="text"
                      name="paymentID"
                      value={paymentID}
                      placeholder={"ID"}
                      onChange={(e) => setPaymentID(e.target.value)}
                    />
                  </div>
                </div>

                {(affiliateInfo?.user?.role !== "companyManager" || affiliateInfo?.user?.role !== "teacher") && (
                  <div>
                    <div className="wrapperBlock">
                      <h4 className="textBlock">{t("LANGUAGE")}</h4>

                      <button name="addlanguage" className="addInput" onClick={(e) => addLanguage(e)}>
                        {t("ADD_LANGUAGE")} +
                      </button>
                    </div>

                    <div
                      className="wrapperLanguage"
                      style={languages?.filter((item) => !item.isNative).length === 0 ? { marginBottom: 25 } : {}}
                    >
                      <div
                        className="languageMain"
                        style={languages?.filter((item) => !item.isNative).length === 0 ? { marginBottom: 25 } : {}}
                      >
                        <div>
                          <label htmlFor="language">{t("NATIVE_LANGUAGE")}</label>
                          <span className="invalid">{validations["nativelanguage"] && t("REQUIRED_FIELD")}</span>
                        </div>
                        <div>
                          <select
                            name="language"
                            className="language inputMobile"
                            onChange={(e) => handleChangeList(e, 0)}
                            value={validationLanguageNative ? validationLanguageNative : ""}
                          >
                            <option value="">{t("SELECT")}</option>
                            {globallanguages?.map((item) => (
                              <option key={"nativ" + item.id} value={item.id}>
                                {item.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      {languages?.filter((item) => !item.isNative).length !== 0 && <div className="divSeparation" />}

                      <div className="otherLanguage">
                        {languages?.filter((item) => !item.isNative).length !== 0 && (
                          <div className="wrapperLabel">
                            <label>{t("OTHER_LANGUAGE")}</label>
                          </div>
                        )}

                        <div className="wrapperOtherLanguage">
                          {languages
                            ?.filter((item) => !item.isNative)
                            ?.map((item, index) => {
                              return (
                                <div key={index}>
                                  <div style={{ marginTop: -13, display: "flex" }}>
                                    <select
                                      name="language"
                                      id={"language" + index}
                                      value={item.languageId}
                                      className="language inputMobile"
                                      onChange={(e) => handleChangeList(e, index)}
                                    >
                                      <option value="">{t("SELECT")}</option>
                                      {globallanguages.map((item) => (
                                        <option key={"gLang" + item.id} value={item.id}>
                                          {item.name}
                                        </option>
                                      ))}
                                    </select>

                                    <button
                                      id={index}
                                      name="removelanguage"
                                      className="buttonRemovelanguage"
                                      onClick={(e) => removeLanguage(e, index)}
                                    >
                                      X
                                    </button>
                                  </div>
                                </div>
                              );
                            })}
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {affiliateInfo?.user.role === "teacher" && (
                  <div>
                    <div className="wrapperBlock">
                      <h4 className="textBlock">{t("LANGUAGE")}</h4>
                    </div>

                    <div className="wrapperLanguage">
                      <div
                        style={
                          languagesTeacher?.filter((item) => !item.isNative).length === 0 ? { marginBottom: 25 } : {}
                        }
                      >
                        {languagesTeacher
                          .filter((item) => item.isNative)
                          .map((item, i) => (
                            <div key={i} className="languageMain">
                              <div>
                                <label htmlFor="language">{t("NATIVE_LANGUAGE")}</label>
                                <span className="invalid">{validations["nativelanguage"] && t("REQUIRED_FIELD")}</span>
                              </div>

                              <div>
                                <select
                                  disabled
                                  name="language"
                                  value={item.languageId}
                                  className="language inputMobile"
                                >
                                  <option value="">{t("SELECT")}</option>
                                  {globallanguages?.map((item) => (
                                    <option key={item.id} value={item.id}>
                                      {item.name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          ))}
                      </div>

                      {languagesTeacher?.filter((item) => !item.isNative).length !== 0 && (
                        <div className="divSeparation" />
                      )}

                      <div className="otherLanguage">
                        {languagesTeacher?.filter((item) => !item.isNative).length !== 0 && (
                          <div className="wrapperLabel">
                            <label>{t("OTHER_LANGUAGE")}</label>
                          </div>
                        )}

                        <div className="wrapperOtherLanguage">
                          {languagesTeacher
                            .filter((item) => !item.isNative)
                            .map((item, index) => {
                              return (
                                <div key={index}>
                                  <div style={{ marginTop: -13, display: "flex" }}>
                                    <select
                                      disabled
                                      id={index}
                                      name="language"
                                      value={item.languageId}
                                      className="language inputMobile"
                                    >
                                      <option value="">{t("SELECT")}</option>
                                      {globallanguages.map((item) => (
                                        <option key={item.id} value={item.id}>
                                          {item.name}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                </div>
                              );
                            })}
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div className="wrapperConfigButtons">
                  <div className="lineInputs">
                    <label htmlFor="isActive">{t("ISACTIVE")}</label>

                    <div className="switch__container">
                      <input
                        type="checkbox"
                        name="isActive"
                        checked={isActive}
                        id="switch-shadow3"
                        className="switch switch--shadow2"
                        onChange={(e) => setIsActive(e.target.checked)}
                      />
                      <label htmlFor="switch-shadow3">{t("YES")}</label>
                    </div>
                  </div>

                  <div>
                    <div>
                      <label htmlFor="password">{t("PASSWORD")}</label>
                      {firstAccess && <span className="invalid">{validations["password"] && t("REQUIRED_FIELD")}</span>}
                    </div>
                    <button type="button" className="password" onClick={openModalPassword}>
                      {t("CHANGE_PASSWORD")}
                    </button>
                  </div>
                </div>
              </form>
            </div>
            <div className="buttonSave">
              <button type="submit" onClick={handleSubmit}>
                {t("BTN_SAVE")}
              </button>
            </div>
          </div>
        </div>
      </div>

      <Dialog
        open={openalert}
        onClose={closeAlert}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="boxModal"
      >
        <DialogTitle id="alert-dialog-title">
          <span className="titleModal">{alerttitle}</span>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="pass-dialog-description" className="boxModal">
            <span className="formulario">
              <span className="description">{alertdescription}</span>
            </span>
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <div className="buttons">
            <button onClick={closeAlert} color="primary" autoFocus>
              {t("CLOSE")}
            </button>
          </div>
        </DialogActions>
      </Dialog>

      <ModalChangePassword id={id} showModal={openmodalpass} setShowModal={setOpenModalPass} />
    </div>
  );
}

export default PersonalInfo;
